<template>
    <div style="padding-bottom: 6rem">
        <header>
            <h1>PRÉ CADASTRO OPERADORA</h1>
        </header>
        <section class="consulta-cadastro">
            <div class="row">
                <h2>LISTA OPERADORAS</h2>
                <div class="filtro">
                    <input class="form-control" type="text" v-model="filtro" placeholder="Filtrar">
                </div>
                <div class="col">
                    <fieldset>
                        <table v-if="operadoras.length > 0" class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Código</th>
                                    <th>Operadora</th>
                                    <th>Situação</th>
                                    <th>Responsável</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="operadora in operadorasPaginadas">
                                    <td>{{ operadora.parceiros.operadora.id }}</td>
                                    <td style="text-align: left;">{{ operadora.cpfCnpj + ' | ' +
                                        operadora.parceiros.operadora.nomeFantasia }}</td>
                                    <td>{{ formatarSituacao(operadora.situacao) }}</td>
                                    <td>{{ operadora.parceiros.operadora.cpfRespv }}</td>
                                    <td><button class="btn-secondary"
                                            @click="listarUsuarios(operadora.parceiros.operadora.id)"><i
                                                class="fa-solid fa-person"></i></button></td>
                                </tr>
                            </tbody>
                        </table>
                    </fieldset>
                </div>
                <div class="d-flex justify-content-center">
                    <div class="paginacao">
                        <button class="btn-secondary me-2"
                            @click="mudarPagina('operadora', paginacao.operadora.paginaAtual - 1)"
                            :disabled="paginacao.operadora.paginaAtual === 1">
                            <i class="fa-solid fa-chevron-left"></i>
                        </button>
                        <button v-for="pagina in paginasVisiveis('operadora')" :key="pagina"
                            :class="['btn btn-secondary', 'me-1', { active: paginacao.operadora.paginaAtual === pagina }]"
                            @click="mudarPagina('operadora', pagina)"> {{
                            pagina
                            }} </button>
                        <button class="btn-secondary ms-1"
                            @click="mudarPagina('operadora', paginacao.operadora.paginaAtual + 1)"
                            :disabled="paginacao.operadora.paginaAtual === totalDePaginas('operadora')">
                            <i class="fa-solid fa-chevron-right"></i>
                        </button>
                    </div>
                </div>
                <div class="d-flex justify-content-center mt-3"> Página {{ paginacao.operadora.paginaAtual }} de {{
                    totalDePaginas('operadora')
                    }} </div>
            </div>
        </section>
        <div v-if="visivel" @click="fechar" class="modal-overlay">
            <div class="modalUsuarios" @click.stop>
                <div class="modal-header">
                    <h2>Usuários da Operadora {{ operadoraSelecionada && operadoraSelecionada.nomeFantasia }}</h2>
                    <button class="close-btn" @click="fechar"><i class="fa-solid fa-x close-btn"></i></button>
                </div>
                <fieldset>
                    <table v-if="usuarios.length > 0" class="table table-striped">
                        <thead>
                            <tr>
                                <th>CPF</th>
                                <th>Nome</th>
                                <th>E-mail</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="usuario in usuariosPaginados">
                                <td>{{ usuario.cpfCnpj }}</td>
                                <td style="text-align: left;">{{ usuario.nome.toUpperCase() }}</td>
                                <td style="text-align: left;">{{ usuario.email.toUpperCase() }}</td>
                            </tr>
                        </tbody>
                    </table>
                </fieldset>
                <div class="d-flex justify-content-center">
                    <div class="paginacao">
                        <button class="btn-secondary me-2"
                            @click="mudarPagina('usuarios', paginacao.usuarios.paginaAtual - 1)"
                            :disabled="paginacao.usuarios.paginaAtual === 1">
                            <i class="fa-solid fa-chevron-left"></i>
                        </button>
                        <button v-for="pagina in paginasVisiveis('usuarios')" :key="pagina"
                            :class="['btn btn-secondary', 'me-1', { active: paginacao.usuarios.paginaAtual === pagina }]"
                            @click="mudarPagina('usuarios', pagina)"> {{
                            pagina
                            }} </button>
                        <button class="btn-secondary ms-1"
                            @click="mudarPagina('usuarios', paginacao.usuarios.paginaAtual + 1)"
                            :disabled="paginacao.usuarios.paginaAtual === totalDePaginas('usuarios')">
                            <i class="fa-solid fa-chevron-right"></i>
                        </button>
                    </div>
                </div>
                <div class="d-flex justify-content-center mt-3"> Página {{ paginacao.usuarios.paginaAtual }} de {{
                    totalDePaginas('usuarios')
                    }} </div>
            </div>
        </div>
        <div class="loader">
            <div>
                <div class="spinner-border"></div>
            </div>
        </div>
    </div>
</template>

<script>
import * as alertUtils from '@/utils/alert';
import * as ajaxUtils from '@/utils/ajax';

const baseUrl = "/massificados/corporativo/gerenciador-parceiros/rest/pre-cadastro-operadora-api";

export default {
    data() {
        return {
            operadoras: [],
            operadoraSelecionada: null,
            usuarios: [],
            filtro: '',
            paginacao: {
                operadora: {
                    paginaAtual: 1,
                    itensPorPag: 10
                },
                usuarios: {
                    paginaAtual: 1,
                    itensPorPag: 5
                }
            },
            visivel: false,
            carregandoUsuarios: false

        }
    },
    computed: {

        filtrar() {
            const query = String(this.filtro || '').toLowerCase();

            const toStr = (v) => (v == null ? '' : String(v));
            const toLow = (v) => toStr(v).toLowerCase();

            return (this.operadoras || []).filter((operadora) => {
            const op = (operadora && operadora.parceiros && operadora.parceiros.operadora)
                ? operadora.parceiros.operadora
                : {};

            const id          = toStr(op.id);
            const cpfCnpj     = toLow(operadora && operadora.cpfCnpj);
            const nome        = toLow(op.nomeFantasia);
            const situacao    = toLow(op.situacao);
            const cpfRespv    = toLow(op.cpfRespv);

            return (
                id.includes(query) ||
                cpfCnpj.includes(query) ||
                nome.includes(query) ||
                situacao.includes(query) ||
                cpfRespv.includes(query)
            );
            });
        },
        operadorasPaginadas() {

            const paginaAtual = this.paginacao.operadora.paginaAtual;
            const itensPorPag = this.paginacao.operadora.itensPorPag;

            const inicio = (paginaAtual - 1) * itensPorPag;
            const fim = inicio + itensPorPag;
            return this.filtrar.slice(inicio, fim);
        },

        usuariosPaginados() {
            const paginaAtual = this.paginacao.usuarios.paginaAtual;
            const itensPorPag = this.paginacao.usuarios.itensPorPag;
            const inicio = (paginaAtual - 1) * itensPorPag;
            const fim = inicio + itensPorPag;
            return this.usuarios.slice(inicio, fim);
        }
    },
    watch: {
        filtro() {
            this.paginacao.operadora.paginaAtual = 1;
        }
    },
    methods: {
        formatarSituacao(situacao) {
            if (!situacao) return "";

            const valor = situacao.toUpperCase();

            if (valor === "PRE" || valor === "FIN") return "CADASTRADA";
            if (valor === "BUP") return "AGUARDANDO CADASTRO";
            if (valor === "ALP") return "AGUARDANDO PLD";

            return valor;
        },
                
        async listarOperadoras(validar = (data) => Array.isArray(data) && data.length > 0) {
            try {
                const mensagemErro = 'Nenhuma operadora ativa encontrada!'
                const dados = await ajaxUtils.get(baseUrl + '/listar-operadoras-tela-consulta', true);

                if (!validar(dados))
                    alertUtils.alertError(mensagemErro);
                else
                    this.operadoras = dados;
            } catch (error) {
                console.error("Erro na requisição:", error);
                alertUtils.alertError("Erro de rede ou servidor. Tente novamente.");
            }
        },
        async listarUsuarios(idOperadora) {
            try {
                this.carregandoUsuarios = true;

                const dados = await ajaxUtils.get(baseUrl + '/listar-usuario/' + idOperadora, true);

                if (!Array.isArray(dados) || dados.length === 0)
                    alertUtils.alertError('Nenhum usuário encontrado!');
                else {
                    this.visivel = true;
                    this.usuarios = dados;
                    this.operadoraSelecionada = this.operadoras.find(operadora => operadora.parceiros.operadora.id === idOperadora)
                }
            } catch (error) {
                console.error("Erro na requisição de usuários: ", error);
                alertUtils.alertError("Erro ao carregar os usuários. Tente novamente.");
            } finally {
                this.carregandoUsuarios = false;
            }
        },
        mudarPagina(tipo, pagina) {
            const total = this.totalDePaginas(tipo);
            if (pagina < 1) pagina = 1;
            else if (pagina > total) pagina = total;

            this.paginacao[tipo].paginaAtual = pagina;
        },
        totalDePaginas(tipo) {
            let dadosFiltrados = tipo === 'operadora' ? this.filtrar : this.usuarios;
            const itensPorPag = this.paginacao[tipo].itensPorPag;
            return Math.ceil(dadosFiltrados.length / itensPorPag);
        },
        paginasVisiveis(tipo) {
            const paginaAtual = this.paginacao[tipo].paginaAtual;
            const totalDePaginas = this.totalDePaginas(tipo);
            const paginas = [];

            if (totalDePaginas <= 3) {
                for (let i = 1; i <= totalDePaginas; i++) paginas.push(i);
            } else {
                const inicio = Math.max(1, paginaAtual - 1);
                const fim = Math.min(totalDePaginas, inicio + 2);
                for (let i = inicio; i <= fim; i++) paginas.push(i);

                if (paginas.length < 3) {
                    if (paginas[0] > 1) paginas.unshift(paginas[0] - 1);
                    if (paginas[paginas.length - 1] < totalDePaginas) paginas.push(paginas[paginas.length - 1] + 1);
                }
            }

            return paginas;
        },
        fechar() {
            this.visivel = false;
            this.usuarios = [];
        }
    },
    mounted() {
        this.listarOperadoras();
    }
}

</script>

<style scoped>
@import '/massificados/corporativo/gerenciador-parceiros-ui/consulta-cadastro-operadora/css/style.css';
</style>